import axios from 'axios';

/* eslint no-param-reassign: ["error"] */
const currentState = {
  activeProducts: [],
  activeProductsNotGrouped: [],
  inactiveProducts: [],
};

const mutations = {
  set_products(state, { activeProducts, inactiveProducts, activeProductsNotGrouped }) {
    state.activeProducts = activeProducts;
    state.activeProductsNotGrouped = activeProductsNotGrouped;
    state.inactiveProducts = inactiveProducts;
  },
};

const actions = {
  async getProducts({ commit }, code) {
    try {
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/products`);
      commit('set_products', {
        activeProducts: data.active,
        inactiveProducts: data.inactive,
        activeProductsNotGrouped: data.notGrouped,
      });

      return data;
    } catch ({ response }) {
      console.log(response);
    }
  },
};

const getters = {
  activeProducts: state => state.activeProducts,
  activeProductsNotGrouped: state => state.activeProductsNotGrouped,
  inactiveProducts: state => state.inactiveProducts,
  productById: state => id => state.activeProductsNotGrouped.find((p) => {
    console.log(p);
    return p.product_info.product.id == id;
  }),
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
